import React from 'react';
import { Icon, Button } from '@repo/ui';

interface ErrorStateProps {
  error: Error;
  onRetry: () => void;
}

export const ErrorState: React.FC<ErrorStateProps> = ({ error, onRetry }) => {
  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center max-w-md">
        <Icon name="HiExclamation" className="h-16 w-16 text-red-500 mx-auto mb-4" />
        <h2 className="text-2xl font-semibold text-xtnd-dark-800 dark:text-white mb-2">
          Failed to Load Settings
        </h2>
        <p className="text-xtnd-dark-500 dark:text-xtnd-dark-300 mb-6">{error.message}</p>
        <Button
          onClick={onRetry}
          variant="primary"
          leftIcon={<Icon name="HiRefresh" className="h-5 w-5" />}
        >
          Retry
        </Button>
      </div>
    </div>
  );
};

